import React from "react";
import Image from "next/image";
import "../styles/globals.scss";
import style from "../styles/style_sections/hero.module.scss";

export default function Hero() {
  return (
    <section className={style.hero} aria-labelledby="hero-title">
      <div className={style.heroBackgroundWrapper}>
        <Image
          src="/assets/background-hero.webp"
          alt=""
          fill
          style={{ objectFit: "cover" }}
          priority
          quality={40}
        />
      </div>
      <div className={style.heroOverlay}></div>
      <div className={style.container}>
        <div className={`${style.heroContentWrapper} fade-in-up`}>
          <div className={style.heroText}>
            <div className={style.heroHeader}>
              <h1 id="hero-title" className={style.heroMainTitle}>
                Renata Oliveira
              </h1>
              <h2 className={style.heroSubtitle}>Advocacia</h2>
            </div>
            <p className={style.heroParagraph}>
              Com mais de 10 anos de experiência na área jurídica e
              administrativa, ajudo pessoas e empresas a encontrarem soluções
              eficazes e estratégicas para seus desafios legais.
            </p>
            <div className={style.ctaButtons}>
              <a href="#contato" className={style.primaryBtn}>
                Agende sua consulta
              </a>
              <a href="#sobre" className={style.secondaryBtn}>
                Conheça meu trabalho
              </a>
            </div>
          </div>
          <div className={style.heroImage}>
            <div className={style.heroWrapperImage}>
              <Image
                src="/personal-images/personal-image.webp"
                alt="Renata Oliveira sentada na cadeira sorrindo"
                width={400}
                height={500}
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
